'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _createReducer;

var _createReducer2 = require('../createReducer');

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = require('./actions');

var _actions2 = require('../User/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function favoriteItemAdd(favoritesState, _ref) {
  var item = _ref.item;

  var existingIndex = favoritesState.items.findIndex(function (_ref2) {
    var favoriteId = _ref2.favoriteId;
    return favoriteId === item.favoriteId;
  });
  var items = favoritesState.items.concat([item]);

  if (existingIndex > -1) {
    items.splice(existingIndex, 1);
  }

  if (!process.env.REACT_APP_SERVER) {
    window.localStorage.setItem('favorite_items', (0, _stringify2.default)(items));
  }

  return (0, _extends3.default)({}, favoritesState, {
    items: items
  });
}

function favoriteItemRemove(favoritesState, _ref3) {
  var favoriteId = _ref3.favoriteId;

  var items = favoritesState.items.filter(function (item) {
    return item.favoriteId !== favoriteId;
  });

  if (!process.env.REACT_APP_SERVER) {
    window.localStorage.setItem('favorite_items', (0, _stringify2.default)(items));
  }

  return (0, _extends3.default)({}, favoritesState, {
    items: items
  });
}

function favoriteLogout(favoritesState) {
  if (!process.env.REACT_APP_SERVER) {
    window.localStorage.removeItem('favorite_items');
  }

  return (0, _extends3.default)({}, favoritesState, {
    items: [],
    fetched: false
  });
}

function favoriteSetItems(favoritesState, _ref4) {
  var items = _ref4.items,
      fetched = _ref4.fetched;

  if (!process.env.REACT_APP_SERVER) {
    window.localStorage.setItem('favorite_items', (0, _stringify2.default)(items));
  }

  return (0, _extends3.default)({}, favoritesState, {
    items: items,
    fetched: fetched
  });
}

function rehydrate() {
  return {
    items: !process.env.REACT_APP_SERVER ? JSON.parse(window.localStorage.getItem('favorite_items') || '[]') : [],
    fetched: false
  };
}

var reducer = (0, _createReducer3.default)({}, (_createReducer = {
  '@@redux/INIT': rehydrate
}, (0, _defineProperty3.default)(_createReducer, _actions.FAVORITE_ADD, favoriteItemAdd), (0, _defineProperty3.default)(_createReducer, _actions.FAVORITE_REMOVE, favoriteItemRemove), (0, _defineProperty3.default)(_createReducer, _actions2.USER_LOGOUT, favoriteLogout), (0, _defineProperty3.default)(_createReducer, _actions.FAVORITE_SET_ITEMS, favoriteSetItems), _createReducer));

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Favorites/reducer.js
// module id = 864
// module chunks = 0